var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: { "big-screen": !_vm.$vuetify.breakpoint.xsOnly },
      attrs: { id: "step3" },
    },
    [
      _vm.$vuetify.breakpoint.xsOnly && !_vm.menu
        ? _c(
            "v-btn",
            {
              staticClass: "box-shadow",
              attrs: { color: "primary", icon: "" },
              on: {
                click: function ($event) {
                  return _vm.openMenu()
                },
              },
            },
            [_c("v-icon", [_vm._v("search")])],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.$vuetify.breakpoint.xsOnly || _vm.menu
        ? _c(
            "v-menu",
            {
              attrs: { "offset-y": "" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function ({ on }) {
                      return [
                        _c(
                          "v-text-field",
                          _vm._g(
                            {
                              ref: "search",
                              staticClass: "mt-2",
                              attrs: {
                                loading: _vm.isSearching,
                                "append-icon": "search",
                                label: "Jump to Station",
                                clearable: "",
                                color: "white",
                                solo: "",
                                items: _vm.filteredItems,
                                "item-text": "primaryName",
                                "item-value": "id",
                                "return-object": "",
                              },
                              on: {
                                input: function ($event) {
                                  _vm.menu = true
                                },
                              },
                              model: {
                                value: _vm.search,
                                callback: function ($$v) {
                                  _vm.search = $$v
                                },
                                expression: "search",
                              },
                            },
                            on
                          )
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                2327364068
              ),
              model: {
                value: _vm.menu,
                callback: function ($$v) {
                  _vm.menu = $$v
                },
                expression: "menu",
              },
            },
            [
              _vm._v(" "),
              _c(
                "v-card",
                [
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", flexbox: "" } },
                        [
                          _c("v-subheader", [_vm._v(_vm._s(_vm.title))]),
                          _vm._v(" "),
                          _c(
                            "v-list",
                            { attrs: { "two-line": "" } },
                            _vm._l(_vm.shownLocations, function (item, index) {
                              return _c(
                                "v-list-tile",
                                {
                                  key: `item-${index}`,
                                  attrs: {
                                    to: {
                                      name: "monitoringfeature",
                                      params: { monitoringFeatureId: item.id },
                                    },
                                    "active-class": "activeStation",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.clearSearch()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(item.primaryName)
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "stationHere caption float_right",
                                          },
                                          [_vm._v("You are here")]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-sub-title",
                                        [
                                          item.allNames.length
                                            ? _c("span", [
                                                _vm._v("Data types: "),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm._l(
                                            item.dataTypes,
                                            function (dataType, subIindex) {
                                              return _c(
                                                "v-chip",
                                                {
                                                  key: subIindex,
                                                  attrs: { small: "" },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(dataType.type) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }